import AddressForm from "@/components/AddressForm";
import Error from "@/components/Error";
import User from "@/services/User";
import ParseHTTPError from "@/helpers/ParseHTTPError";
import { mapState } from "vuex";
import _ from "lodash";

import moment from "moment";
import i18n from "@/services/i18n";

export default {
  data: () => ({
    isEditable: true,
    isNew: true,
    isCoach: true,
    loading: true,

    communities: ["fll-brasil"],

    valid: false,
    doesHaveAccount: false,
    selected: [],

    availableCommunities: [
      {
        text: "First Lego League",
        value: "fll-brasil",
        communityId: "fll-brasil",
      },
      {
        text: "First Tech Challenge",
        value: "ftc-brasil",
        communityId: "ftc-brasil",
      },
      {
        text: "First Robotics Challenge",
        value: "frc-brasil",
        communityId: "frc-brasil",
      },
      { text: "F1 in Schools", value: "f1-brasil", communityId: "f1-brasil" },
      { text: "F1 in Schools", value: "stem-racing", communityId: "f1-brasil" },
      {
        text: "Desafio SESI de Robótica COVID-19",
        value: "desafiocovid",
        communityId: "desafiocovid",
      },
      {
        text: "Desafio Relâmpago - Volta às Aulas",
        value: "desafiorelampago",
        communityId: "desafiorelampago",
      },
      {
        text: "FLL Open Brasil",
        value: "fll-open-brazil",
        communityId: "fll-open-brazil",
      },
      {
        text: "Off Season SESI MT",
        value: "off-season-sesi-mt",
        communityId: "off-season-sesi-mt",
      },
    ],

    model: {
      name: null,
      birth: null,
      cpf: null,
      alias: null,
      general: {
        gender: null,
        phone: null,
        cellphone: null,
      },
      roles: [],
      address: {},
      formation: {
        formation: null,
        school: null,
        series: null,
      },
      judge: {
        experience: null,
        language: [],
      },
    },

    rules: {
      atLeastOne: (selected) =>
        selected.length > 0 || "Pelo menos uma opcao precisa estar selecionada",
    },
  }),
  created() {
    if (this.user) {
      this.$store.dispatch("getUserInfo", () => {
        this.$store.dispatch("updateMe");
        this.loading = false;
      });
    } else {
      setTimeout(() => {
        this.loading = false;
      }, 400);
    }

    // defaults to fll-brasil, but looks up for url params
    let competition = this.$route.params.community;
    if (competition) {
      const { communityId } = _.find(this.availableCommunities, {
        value: competition,
      });
      this.communities = communityId ? [communityId] : ["fll-brasil"];
    }

    // if community is fll-open-brazil has a roles default value = judge
    if (competition == "fll-open-brazil") {
      i18n.locale = "en";
      this.model.roles = ["robotics:coach"];
    }
  },
  watch: {
    user() {
      this.model = _.merge({}, this.model, this.user);
    },

    model: {
      async handler(val) {
        const userDocument = val.cpf ? val.cpf : "";
        if (!this.user && userDocument.length === 14) {
          if (this.doesHaveAccount) return;
          // check user exists in one of the commuties
          const userExists = [
            ...(this.$route.params.community
              ? this.communities
              : _.map(this.availableCommunities, "communityId")),
          ].map(async (communityId) => {
            try {
              const response = await User.exists(userDocument, {
                "community-id": communityId,
              });
              return {
                ...response.data,
                community: communityId,
              };
            } catch (e) {
              return {
                exists: false,
                community: communityId,
              };
            }
          });

          const resolved = await Promise.all(userExists);
          const hasAccounts = resolved
            .filter((r) => r.exists)
            .map((r) => r.community);

          if (!hasAccounts.length) {
            this.doesHaveAccount = true;
            console.log("Does not have account");
            return;
          }

          const currentCommunity = this.communities[0];

          // check if community if has account in community it is trying to create
          if (hasAccounts.includes(currentCommunity)) {
            return this.$dialog({
              title: "Ops",
              content:
                "Uma conta com esse CPF já existe. Deseja acessar sua conta?",
              closeOnClickModal: false,
              buttons: [
                { name: "Cancelar", class: "grey--text" },
                { name: "Login", action: true, class: "green--text" },
              ],
            }).then(() => {
              location.href = "https://torneios-cni.layers.education/login";
            });
          }

          const communityUserHasAccount = _.find(this.availableCommunities, {
            communityId: hasAccounts[0],
          });

          this.$dialog({
            title: "Ops",
            content: `Você já possui uma conta na ${communityUserHasAccount.text}. Deseja reaproveitar seu cadastro?`,
            buttons: [
              { name: "Cancelar", class: "grey--text" },
              { name: "Sim", action: true, class: "green--text" },
            ],
            closeOnClickModal: false,
          })
            .then(() => {
              User.copy(
                userDocument,
                {
                  to: this.communities[0],
                },
                {
                  "community-id": communityUserHasAccount.value,
                }
              )
                .then(() => {
                  location.href = "https://torneios-cni.layers.education/login";
                })
                .catch((err) => {
                  const status = ParseHTTPError(err);
                  let error = status.error;

                  if (!status.type) {
                    error =
                      "Houve um erro na comunicação com o servidor, tente novamente";
                  }

                  this.$notify.error({
                    title: "Erro na atualização",
                    message: error,
                  });
                });
            })
            .catch(() => {});
        } else {
          this.userExists = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    backgroundUrl() {
      return {
        test:
          "https://cdn.edu.tenda.digital/fll-brasil/uploads/f4c105f4-2764-40df-84df-97e3ab24201e/oie_SYJTWdQ7bbQr.png",
        "fll-brasil":
          "https://cdn.layers.digital/admin/uploads/5be5f14f-9dfc-4eb2-bbb4-80ae9d9f57e1/unearthed.png",
        "frc-brasil":
          "https://cdn.layers.digital/admin/uploads/1cacfa48-323f-4c7b-83ee-8ee5a96558f8/rebuilt.png",
        "ftc-brasil":
          "https://cdn.layers.digital/admin/uploads/7bfe858a-53f1-42d5-943f-f7cab0865bd2/decode.png",
        "f1-brasil":
          "https://cdn.layers.digital/admin/uploads/1ff43442-ab52-4aca-b2fd-490bfeda4700/stemracing.png",
        desafiocovid:
          "https://cdn.layers.digital/admin/uploads/84f9fda8-b83e-4d8f-b36b-70804921281d/Ativo-1100-1.png",
        desafiorelampago:
          "https://cdn.edu.tenda.digital/fll-brasil/uploads/f4c105f4-2764-40df-84df-97e3ab24201e/oie_SYJTWdQ7bbQr.png",
        "fll-open-brazil":
          "https://cdn.staging.layers.digital/staging/uploads/f1c3eb67-15fb-48a9-b9ef-fcba7b3ed1e7/fll2.png",
        "off-season-sesi-mt":
          "https://cdn.edu.tenda.digital/fll-brasil/uploads/f4c105f4-2764-40df-84df-97e3ab24201e/oie_SYJTWdQ7bbQr.png",
      }[this.communities[0]];
    },

    color() {
      return {
        test: "background-color: #945D7C;",
        "fll-brasil": "background-color: #E5AE32;",
        "frc-brasil": "background-color: #468292;",
        "ftc-brasil": "background-color: #77DDA7;",
        "f1-brasil": "background-color: #222;",
        desafiocovid: "background-color: #794db8;",
        desafiorelampago: "background-color: #945D7C;",
        "fll-open-brazil": "background-color: #945D7C;",
        "off-season-sesi-mt": "background-color: #945D7C;",
      }[this.communities[0]];
    },

    possibleGender() {
      return [
        { label: this.$t("general.gender.male"), _id: "male" },
        { label: this.$t("general.gender.female"), _id: "female" },
        { label: this.$t("general.gender.other"), _id: "other" },
      ];
    },

    possibleFormation() {
      return [
        {
          label: this.$t("general.formation.fundamental-incomplete"),
          _id: "fundamental-incomplete",
        },
        {
          label: this.$t("general.formation.fundamental-complete"),
          _id: "fundamental-complete",
        },
        {
          label: this.$t("general.formation.medio-incomplete"),
          _id: "medio-incomplete",
        },
        {
          label: this.$t("general.formation.medio-graduating"),
          _id: "medio-graduating",
        },
        {
          label: this.$t("general.formation.medio-complete"),
          _id: "medio-complete",
        },
        {
          label: this.$t("general.formation.superior-complete"),
          _id: "superior-complete",
        },
        {
          label: this.$t("general.formation.mestrado-complete"),
          _id: "mestrado-complete",
        },
        {
          label: this.$t("general.formation.doutorado-complete"),
          _id: "doutorado-complete",
        },
        {
          label: this.$t("general.formation.pos-doutorado-complete"),
          _id: "pos-doutorado-complete",
        },
        { label: this.$t("general.formation.none"), _id: "" },
      ];
    },

    availableRoles() {
      return [
        { text: this.$t("general.judge"), value: "robotics:judge" },
        { text: this.$t("general.coach"), value: "robotics:coach" },
      ];
    },

    possibleLanguages() {
      return [
        { label: this.$t("general.languages.portuguese"), _id: "portuguese" },
        { label: this.$t("general.languages.english"), _id: "english" },
        { label: this.$t("general.languages.spanish"), _id: "spanish" },
      ];
    },

    isCreatingJudge() {
      return this.model.roles.includes("robotics:judge");
    },

    ...mapState(["user", "isJudge"]),

    formatedBirth() {
      const val = this.model.birth;
      if (val && val.match(/^\d\d\d\d-\d\d-\d\dT?/)) {
        const newVal = moment(val).utc();
        if (newVal.isValid()) {
          return this.comunity === "fll-open-brazil"
            ? newVal.format("MM/DD/YYYY")
            : newVal.format("DD/MM/YYYY");
        }
      }
      return val;
    },
  },
  methods: {
    goBack() {
      return this.$router.back();
    },
    submit() {
      this.$validator.validateAll().then((result) => {
        // If throw errors in form, return
        if (!result) {
          this.$notify.error({
            title: "Encontramos alguns erros",
            message: this.$createElement("Error", {
              props: {
                error: this.errors,
              },
            }),
          });

          return;
        }

        !this.user && this.save();
        this.user && this.update();
      });
    },
    update() {
      const userId = this.user.id || this.user._id;

      User.update(this.model, userId)
        .then(() => {
          this.loading = false;

          this.$notify.success({
            title: "Usuário atualizado",
            message: "Seu usuário foi atualizado com sucesso",
          });
        })
        .catch((err) => {
          this.loading = false;

          const status = ParseHTTPError(err);
          let error = status.error;

          if (!status.type) {
            error =
              "Houve um erro na comunicação com o servidor, tente novamente";
          }

          this.$notify.error({
            title: "Erro na atualização",
            message: error,
          });
        });
    },
    save() {
      const createdUser = this.communities.map((community, index) => {
        // only invite one time
        const payload = index == 0 ? { invite: true } : {};

        return User.create(
          { ...this.model, ...payload },
          { "community-id": community }
        );
      });

      this.loading = true;

      Promise.all(createdUser)
        .then(() => {
          this.loading = false;

          this.$notify.success({
            title: this.$t("signup.success_registered_user.title"), // 'Usuário cadastrado',
            message: this.$t("signup.success_registered_user.message"), // 'Seu usuário foi cadastrado com sucesso',
          });
        })
        .catch((err) => {
          this.loading = false;

          const errorType = err.response.data.type;
          if (errorType == "Conflict") {
            this.$dialog({
              title: "Erro",
              content: err.response.data.error + ". Deseja acessar sua conta?",
              buttons: [
                { name: "Cancelar", class: "grey--text" },
                { name: "Login", action: true, class: "green--text" },
              ],
            }).then(() => {
              location.href =
                "https://torneios-cni.edu.tenda.digital/login?email=" +
                this.model.email;
            });
            return;
          }

          const status = ParseHTTPError(err);
          let error = status.error;

          if (!status.type) {
            error =
              "Houve um erro na comunicação com o servidor, tente novamente";
          }

          this.$notify.error({
            title: "Erro no cadastro",
            message: error,
          });
        });
    },
    validateDate(obj, key) {
      const val = obj[key];
      if (val && val.match(/^\d\d\d\d-\d\d-\d\d$/)) {
        // If its already okay, keep it as it is
      } else if (val && val.match(/^\d\d\/\d\d\/\d\d\d\d$/)) {
        // Try parsing it to the new format
        const newVal =
          this.comunity === "fll-open-brazil"
            ? moment(val, "MM/DD/YYYY")
            : moment(val, "DD/MM/YYYY");
        if (newVal.isValid()) {
          obj[key] = newVal.format("YYYY-MM-DD");
        } else {
          obj[key] = val;
        }
      } else {
        obj[key] = val;
      }
    },
  },
  components: {
    AddressForm,
    Error,
  },
};



// WEBPACK FOOTER //
// ./src/pages/SignUp/SignUp.js